export const COLORS = [
  "White",
  "Clay",
  "Dk Woodgrain/White",
  "Dk Woodgrain/Clay",
];

export const GLASS_TYPES = ["DS", "TS"];

export const GLASS_CONFIGS = [
  { code: "DLA", label: "Dual Lite Argon" },
  { code: "TLA", label: "Triple Lite Argon" },
  { code: "DLC", label: "Dual Lite Clear" },
];

export const SCREEN_TYPES = ["Flex Scrn", "Std Scrn", "None"];
export const MESH_TYPES = ["Plain", "Solar", "Pet"];

export const CONFIGS = {
  DH:   ["Single", "Twin", "Triple", "Quad", "Quin", "Q/H/Q"],
  HS:   ["Single", "Twin", "Triple", "Quad", "Quin"],
  CSMT: ["Single", "2-Lite", "3-Lite", "4-Lite", "5-Lite"],
  PW:   ["Single"],
  BSMT: ["Single"],
  "3HS": ["Single"],
  BM:   ["Single"],
};

export const WINDOW_TYPES = [
  { code: "DH",   label: "Double Hung" },
  { code: "HS",   label: "Horizontal Slider" },
  { code: "CSMT", label: "Casement" },
  { code: "PW",   label: "Picture Window" },
  { code: "BSMT", label: "Basement Hopper" },
  { code: "3HS",  label: "3-Lite Slider" },
  { code: "BM",   label: "Brickmould" },
];

export const FIN_TYPES = ["With Fin", "Without Fin"];
export const GAS_FILLS = ["Argon", "None"];
export const GRID_COLORS = ["White", "Clay", "Black", "Brown"];
export const GRID_PATTERNS = ["Prairie", "Spanned Prairie", "Colonial", "Diamond"];
export const HANDING_OPTIONS = ["Hinge Left", "Hinge Right"];
export const MULL_TYPES = ["Structural", "Cosmetic"];

export const CONFIG_LITES = {
  Single: 1,
  Twin: 2,
  Triple: 3,
  Quad: 4,
  Quin: 5,
  "Q/H/Q": 4,
  "2-Lite": 2,
  "3-Lite": 3,
  "4-Lite": 4,
  "5-Lite": 5,
};